// # #############################################
// # Title : Map Legend
// # Authors : Atul
// # Date : 15th October 2019
// # Last Modified : Atul, September 2019
// # Version : 19.10.03
// # Description : This is the code for the Legend on the Mapbox Element in Country View
// # ############################################

import React from 'react';
import { select, scaleLinear, axisBottom } from 'd3';
import { abbreviateNumber } from "../utils/helperFunction";

function initialSizeChecker(width) {

    let widthToSet = 100 + (width - 200) / 6;

    if (widthToSet > 200) {
        widthToSet = 200;
    }
    else if (widthToSet < 100) {
        widthToSet = 100;
    }

    return widthToSet;
}

class Main extends React.Component {
    state = {
        pallete: this.props.colors,
        widthIncoming: initialSizeChecker(this.props.width)
    };


    componentDidMount() {
        this.draw();
        this.legendLabelModifier();
    }

    
    componentDidUpdate() {
        this.legendLabelModifier();
    }


    draw = () => {
        
        const { ticks } = this.props;
        let { maxCount } = this.props;

        if (maxCount > 10 && maxCount <= 100) {
            maxCount = maxCount + 5;
        }

        //define group and join
        let key = select(this.node)

        const h = 45;
        const opacity = 0.8;

        var y = scaleLinear()
            .range([this.state.widthIncoming - 10, 5])
            .domain([maxCount, 0])


        var yAxis = axisBottom()
            .scale(y.nice())
            .ticks(ticks);

        key.enter()
            .append("svg")
            .attr("width", this.state.widthIncoming)
            .attr("height", h);

        var legend = key
            .append("svg:linearGradient")
            .attr("id", "gradient")
            .attr("x1", "0%")
            .attr("y1", "100%")
            .attr("x2", "100%")
            .attr("y2", "100%")
            .attr("spreadMethod", "pad");


        legend.append("stop")
            .attr("offset", "5%")
            .attr("stop-color", this.state.pallete.color1)
            .attr("stop-opacity", opacity);

        legend.append("stop")
            .attr("offset", "20%")
            .attr("stop-color", this.state.pallete.color2)
            .attr("stop-opacity", opacity);

        legend.append("stop")
            .attr("offset", "30%")
            .attr("stop-color", this.state.pallete.color3)
            .attr("stop-opacity", opacity);

        legend.append("stop")
            .attr("offset", "40%")
            .attr("stop-color", this.state.pallete.color4)
            .attr("stop-opacity", opacity);

        legend.append("stop")
            .attr("offset", "50%")
            .attr("stop-color", this.state.pallete.color5)
            .attr("stop-opacity", opacity);

        legend.append("stop")
            .attr("offset", "60%")
            .attr("stop-color", this.state.pallete.color6)
            .attr("stop-opacity", opacity);

        legend.append("stop")
            .attr("offset", "70%")
            .attr("stop-color", this.state.pallete.color7)
            .attr("stop-opacity", opacity);

        legend.append("stop")
            .attr("offset", "80%")
            .attr("stop-color", this.state.pallete.color8)
            .attr("stop-opacity", opacity);

        legend.append("stop")
            .attr("offset", "90%")
            .attr("stop-color", this.state.pallete.color9)
            .attr("stop-opacity", opacity);

        legend.append("stop")
            .attr("offset", "95%")
            .attr("stop-color", this.state.pallete.color10)
            .attr("stop-opacity", opacity);

        key.append("rect")
            .attr("class", "update")
            .merge(key)
            .attr('x', 5)
            .attr("width", `${this.state.widthIncoming - 10}`)
            .attr("height", h - 30)
            .style("fill", "url(#gradient)")
            .attr("transform", "translate(0,15)");



        key.append("g")
            .merge(key)
            .attr("class", "y axis")
            .attr("transform", "translate(1,30)")
            .call(yAxis)
            .append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 0)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .text("axis title");

        key.exit().remove();


    }


    sizeChecker = (width) => {

        let widthToSet = 100 + (width - 200) / 6;

        if (widthToSet > 200) {
            widthToSet = 200;
        }
        else if (widthToSet < 100) {
            widthToSet = 100;
        }

        return widthToSet;
    }

    svgRemover = () => {
        const child0 = this.node.childNodes[0]
        const child1 = this.node.childNodes[1]
        const child2 = this.node.childNodes[2]
        this.node.removeChild(child0)
        this.node.removeChild(child1)
        this.node.removeChild(child2)
    }
    UNSAFE_componentWillReceiveProps(props) {

        this.setState(
            {
                pallete: props.colors,
                widthIncoming: this.sizeChecker(this.props.width)
            }
        )
    }

    legendLabelModifier = () => {

        const tickItems = document.getElementsByClassName('tick');
        let i;
        for (i = 0; i < tickItems.length; i++) {
            let value = tickItems[i].childNodes[1].innerHTML;
            value = abbreviateNumber(value.split(",").join(""));
            tickItems[i].childNodes[1].innerHTML = value;

        }
    }

    render() {
        if (this.node !== undefined) {
            this.svgRemover();
        }
        this.draw();

        return (
            <svg viewBox="0 0 200 50" width="90%"
                style={{ marginLeft: '4.5%', marginRight: '4.5%' }}
                ref={node => {
                    this.node = node;
                }}
            >
            </svg>
        );
    };
}

export default Main;